import { getListDataFunctionFactory } from '../../../modules/getListDataFunctionFactory'
import type { ILocationType } from '~/types/location/models'
import type { TEntityId, ISelectItem } from '~/types/models'

const locationTypeListData = undefined as unknown as ILocationType[]

export const getLocationTypeListData = getListDataFunctionFactory<
  ILocationType[]
>({
  listData: locationTypeListData,
  storageKey: 'locationtypes',
  getStartingListData: getStartingLocationTypeListData,
})

export function _getLTDataById(
  id: TEntityId,
  list: ILocationType[]
): ILocationType {
  if (!list) {
    throw new Error(`_getLTDataById called with undefined/falsey list`)
  }
  const locationType = list.find((lt: ILocationType) => lt.id === id)
  if (!locationType) {
    throw new Error(`Can't find locationType '${id}'`)
  }
  return locationType
}

export function _getLTSelectItemDataByLabel(
  label: string,
  list: ILocationType[]
): ISelectItem {
  if (!list) {
    throw new Error(`_getLTDataById called with undefined/falsey list`)
  }
  const locationType = list.find((lt) => lt.descr === label)
  if (!locationType) {
    throw new Error(`Can't find locationType '${label}'`)
  }
  return { id: locationType.id, label: locationType.descr }
}

export async function getLocationTypeDataById(
  id: TEntityId
): Promise<ILocationType> {
  const list: ILocationType[] = await getLocationTypeListData()
  return _getLTDataById(id, list)
}

export async function getLocationTypeDataByLabel(
  label: string
): Promise<ILocationType> {
  const list: ILocationType[] = await getLocationTypeListData()
  if (!list) {
    throw new Error(`getLocationTypeListData returned undefined/null`)
  }
  const lt = list.find((locationType) => locationType.label === label)
  if (!lt) {
    throw new Error(`Can't find locationType '${label}'`)
  }
  return lt
}

export async function getLocationTypeSelectItemDataByLabel(
  label: string
): Promise<ISelectItem> {
  const list: ILocationType[] = await getLocationTypeListData()
  return _getLTSelectItemDataByLabel(label, list)
}

export async function getStartingLocationTypeListData(): Promise<
  ILocationType[]
> {
  return [
    { id: 'XXLT001', hrid: 'LT001', descr: 'HQ', canBeDeleted: true },
    { id: 'XXLT002', hrid: 'LT002', descr: 'Branch', canBeDeleted: true },
    { id: 'XXLT003', hrid: 'LT003', descr: 'Office', canBeDeleted: true },
    { id: 'XXLT004', hrid: 'LT004', descr: 'Floor', canBeDeleted: true },
    { id: 'XXLT005', hrid: 'LT005', descr: 'Data Center', canBeDeleted: true },
  ]
}
